import { getMobileOperatingSystem } from "../utils/get_mobile_os";
import { androidAppURL, iosAppURL } from "../config/config";
const AppInstall = () => {
  return (
    <a
      href={
        getMobileOperatingSystem() === "android" ||
        getMobileOperatingSystem() === "windows"
          ? androidAppURL
          : getMobileOperatingSystem() === "ios"
          ? iosAppURL
          : androidAppURL
      }
      className="flex mx-auto items-center justify-center 
      shadow-2xl md:space-y-0 space-x-4 
      md:rounded-xl py-2 px-4 md:py-4 md:px-8
      w-full md:w-3/4 
      bg-gradient-to-r
       to-purple-700 from-blue-600"
    >

      <img 
        src="/assets/r24.png"
        className="w-12 h-12 rounded-2xl"
        alt="r24 logo"
      />

      {/* text */}
      <div className="flex-auto text-left">
        <div className="text-white text-lg sm:text-2xl font-extrabold">
          Try the App:
        </div>
        <div className="text-white mt-2 hidden sm:block">
          Torah, Tehillim, Tania, Talmud, the Rambam's books and the Rebbe's talks - 
          dozens of daily podcasts you can listen to and read on the go!
        </div>
      </div>

      {/* button */}
      <div className="bg-white py-2 px-4 w-fit md:w-fit text-gray-800 rounded-full text-center">
        Download
      </div>
    </a>
  );
};

export default AppInstall;
